import { render } from "./AixamTvComponent.vue?vue&type=template&id=764d6e84"
import script from "./AixamTvComponent.vue?vue&type=script&lang=js"
export * from "./AixamTvComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__